import React from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import { Stack, Typography } from '@mui/material';
import SchedulerTable from './SchedulerTable';
import { useTranslation } from 'react-i18next';
import CusButton from '../../../components/material-ui/CusButton';
import { Link } from 'react-router';
import FlexContainer from '../../../components/material-ui/adaptive/FlexContainer';

export default function Scheduler() {
  const { t } = useTranslation();

  return (
    <CusPageCardContainer
      headTitle={'Mailing scheduler'}
      title={
        <FlexContainer gap={1} justifyContent={'space-between'}>
          <Typography variant="h5"> {t('Mailing scheduler')} </Typography>
          <CusButton
            text="Create a mailing"
            variant="contained"
            LinkComponent={Link}
            to={`/mailing/new`}
          />
        </FlexContainer>
      }>
      <Stack gap={10}>
        <SchedulerTable />
      </Stack>
    </CusPageCardContainer>
  );
}
